export const INTERNAL_ICONS = {
  CLOSE: 'close',
  EXPAND_LESS: 'expand_less',
  EXPAND_MORE: 'expand_more',
  VISIBILITY: 'visibility',
  VISIBILITY_OFF: 'visibility_off',
} as const;

export const ICON_ACTIONS = {
  CLEAR: 'clear',
  TOGGLE_PASSWORD: 'togglePassword',
  NONE: 'none',
} as const;

export const TRANSLATION_PREFIX = 'errors.' as const;
